import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ApmTranslatePipe } from '@mitsubishi/core';
import { PerformanceAlertsComponent } from '@mitsubishi/shared/components';
import {
  AccessoriesErrorConfigCodes,
  ConfigurationErrorCodeResources,
  PerformanceAccessoryErrorConfigCode,
  PerformanceMessage,
} from '@mitsubishi/shared/data-access';
import { ApmFaIconComponent, BaseUiModule } from '@mitsubishi/shared/ui';

export type ConfigurationAlertsDialogComponentProps = {
  messages: PerformanceMessage[];
  workingCondition: string;

  unitName: string;
  externalUnitName?: string;

  unitConfigErrorCode: string | null;
  externalUnitConfigErrorCode?: string;

  accessoriesErrorConfigCodes?: AccessoriesErrorConfigCodes;
};

@Component({
  selector: 'apm-configuration-alerts-dialog',
  templateUrl: './configuration-alerts-dialog.component.html',
  styleUrls: ['./configuration-alerts-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    BaseUiModule,
    PerformanceAlertsComponent,
    PerformanceAlertsComponent,
    ApmTranslatePipe,
    ApmFaIconComponent,
  ],
})
export class ConfigurationAlertsDialogComponent {
  readonly messages = signal<PerformanceMessage[]>([]);
  readonly workingCondition = signal<string>('');

  readonly unitName = signal<string>('');
  readonly externalUnitName = signal<string | undefined>(undefined);

  readonly unitConfigErrorCode = signal<string | null>(null);
  readonly externalUnitConfigErrorCode = signal<string | undefined>(undefined);

  readonly accessoriesErrorConfigCodes = signal<PerformanceAccessoryErrorConfigCode[]>([]);

  configurationErrorCodeResources = ConfigurationErrorCodeResources;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfigurationAlertsDialogComponentProps,
    private dialogRef: MatDialogRef<ConfigurationAlertsDialogComponent>
  ) {
    this.messages.set(data.messages);
    this.workingCondition.set(data.workingCondition);
    this.unitName.set(data.unitName);
    this.unitConfigErrorCode.set(data.unitConfigErrorCode);
    this.accessoriesErrorConfigCodes.set(
      data.accessoriesErrorConfigCodes ? Object.values(data.accessoriesErrorConfigCodes) : []
    );
    this.externalUnitName.set(data.externalUnitName);
    this.externalUnitConfigErrorCode.set(data.externalUnitConfigErrorCode);
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
